import * as React from "react";
import { useLocation } from "react-router-dom";
import { ReactNode, useEffect, useState } from "react";
import mixpanel from "mixpanel-browser";
import {
  aliasUser,
  initMixpanel,
  setUserId,
  setUserProfile,
  trackEvent,
} from "@/services/mixpanel";
import { useAppSelector } from "@/hooks/redux";
import { formatDuration } from "@/utils/datetime";


const MixpanelProvider = ({ children }: { children: ReactNode }) => {
  const { userData } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const [startTime, setStartTime] = useState(Date.now());

  useEffect(() => {

    
    const initAnalytics = () => {
      try {
        initMixpanel();

        if (userData) {
          const anonymousId = mixpanel.get_distinct_id();
          const userId = userData?.user?.id;

          if (userId && anonymousId !== userId) {
            aliasUser(anonymousId, userId);
          }

          if (userId) {
            setUserId(userId);
            setUserProfile({
              ...userData?.user,
            });
          }
        }
      } catch (error) {
        console.error("Mixpanel initialization error:", error);
      }
    };

    initAnalytics();
  }, [userData]);

  useEffect(() => {

    trackEvent(`Page View: ${location.pathname}`, {
      path: location.pathname,
    });

    const handlePageLoad = () => {
      setStartTime(Date.now());
      trackEvent(`Page Stay Start Duration: ${location.pathname}`, {
        page: location.pathname,
        timestamp: new Date().toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
      });
    };

    const handlePageUnload = () => {
      const duration = Date.now() - startTime;
      trackEvent(`Page Stay End Duration: ${location.pathname}`, {
        page: location.pathname,
        duration: formatDuration(duration),
      });
    };

    handlePageLoad();
    window.addEventListener("beforeunload", handlePageUnload);

    return () => {
      window.removeEventListener("beforeunload", handlePageUnload);
      handlePageUnload();
    };
  }, [location.pathname]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default MixpanelProvider;
